import React, { useRef, useState } from "react";
import { getApi } from "../../services/api/globalApi";
import Button from "../../components/common/button/Button";
import {
  errorMessage,
  successMessage,
} from "../../utils/toastify-message/ToastifyMessage";
import { PublicFileUrl } from "../../services/config";
import DateInput from "../../components/common/inputs/DateInput"; 
import UserModal from "../../components/common/modals/user-modal/UserModal";
import { PiXFill } from "react-icons/pi";

function Export() {
  const [fromPaymentDate, setFromPaymentDate] = useState(null);
  const [toPaymentDate, setToPaymentDate] = useState(null);
  const [isExportProccessShipping, setIsExportProccessShipping] = useState(0);
  const [isSabooraOrders, setIsSabooraOrders] = useState("1");
  const [showDateFilters, setShowDateFilters] = useState(false);

  const exportOrders = async () => {
    const path = "admin/exports/exportOrders";
    const params = {
      fromPaymentDate: fromPaymentDate ? fromPaymentDate : undefined,
      toPaymentDate: toPaymentDate ? toPaymentDate : undefined,
      isExportProccessShipping,
      user: user?._id || "",
      isSabooraOrders
    };
    try {
      const response = await getApi({ path, params });
      window.open(
        `${PublicFileUrl}downloads/${response.data.result}`,
        "_blank"
      );
    } catch (error) {
      console.log(error);
      errorMessage(error?.response?.data?.errors[0]?.message);
    }
  };


  const userModalRef = useRef();

  const [user, setUser] = useState(null);
  const [userInfo, setUserInfo] = useState(null);

  const handleUser = (data) => {
    setUser(data);
    setUserInfo(data?.name || data?.mobile);
    successMessage(`کاربر ${data?.name || data?.mobile} انتخاب شد`);
  };

  const deleteUser = () => {
    setUser(null);
    setUserInfo("");
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <UserModal ref={userModalRef} handleUser={handleUser} />
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl text-gray-800 dark:text-white">خروجی دیتا</h3>
        <label className="inline-flex gap-2 items-center cursor-pointer">
          <span className="text-sm font-medium text-gray-900 dark:text-gray-300">
            استفاده از تاریخ
          </span>
          <input
            type="checkbox"
            checked={showDateFilters}
            onChange={() => setShowDateFilters(!showDateFilters)}
            className="sr-only peer"
          />
          <div className="relative w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
        </label>
      </div>

      <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        <div className="relative w-full">
          <span
            onClick={() => userModalRef?.current?.showModal()}
            className="absolute w-full h-full cursor-pointer z-10"
          ></span>
          {user ? (
            <PiXFill
              className="cursor-pointer absolute left-2 bottom-4 text-red-500 z-20"
              onClick={deleteUser}
            />
          ) : null}
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            انتخاب کاربر
          </label>
          <input
            value={userInfo || ""}
            onChange={(e) => setUserInfo(e.target.value)}
            disabled
            placeholder="انتخاب کاربر"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 cursor-pointer"
          />
        </div>

        <div className="w-full">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            وضعیت پرداخت
          </label>
          <div className="relative">
            <select
              value={isExportProccessShipping}
              onChange={(e) => setIsExportProccessShipping(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 pl-8 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 appearance-none"
            >
              <option value={0}>بدون تغییر وضعیت</option>
              <option value={1}>تغیر وضعیت به در حال بسته بندی</option>
            </select>
            <div className="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
              <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        </div>

        <div className="w-full">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            برند
          </label>
          <div className="relative">
            <select
              value={isSabooraOrders}
              onChange={(e) => setIsSabooraOrders(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 pl-8 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 appearance-none"
            >
              <option value={"1"}>صبورا</option>
              <option value={"0"}>عطارباشی</option>
            </select>
            <div className="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
              <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        </div>

        {showDateFilters && (
          <>
            <div className="w-full">
              <DateInput
                label={"از تاریخ"}
                onChange={setFromPaymentDate}
              />
            </div>

            <div className="w-full">
              <DateInput
                label={"تا تاریخ"}
                onChange={setToPaymentDate}
              />
            </div>
          </>
        )}
      </div>

      <div className="mt-6 flex justify-end">
        <Button
          type="button"
          onClick={exportOrders}
          text={"خروجی اکسل"}
          color="success"
        />
      </div>
    </div>
  );
}

export default Export;
